<template>
  <div class="product">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/mallbann.png" alt="" />
    </section>
    <div class="content">
      <section>
        <a
          href="https://momoda.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.28eb179dmwTo1X"
          target="_blank"
        >
          <img src="@/assets/images/tianmao.png" alt="" />
          <p>立即前往登录我们的天猫旗舰店</p>
        </a>
      </section>
      <section>
        <a
          href="https://mall.jd.com/index-10427372.html?from=pc"
          target="_blank"
        >
          <img src="@/assets/images/jingdong.png" alt="" />
          <p>立即前往登录我们的京东旗舰店</p>
        </a>
      </section>
      <section>
        <a
          href="https://m.xiaomiyoupin.com/w/spchome?_rt=weex&spmref=YouPin_A.share.share_pop_copy.4.15777663&id=TvDo_Qguy7e1Q64EkZNp0g&hideNavBar=1&useWebKit=1"
          target="_blank"
        >
          <img src="@/assets/images/xiaomi.png" alt="" />
          <p>立即前往登录我们的小米有品旗舰店</p>
        </a>
      </section>
      <section class="douyin">
        <img src="@/assets/images/douyin.png" alt="" />
        <p>立即前往登录我们的抖音旗舰店</p>
        <div class="none">
          <img src="@/assets/images/douyin_Qr_code.jpg" alt="" />
        </div>
      </section>
    </div>
    <!-- foot -->
    <Foot />
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
export default {
  name: "officialMall",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {};
  },
  mounted() {
    document.getElementById("top").scrollIntoView({ behavior: "smooth" });
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.content {
  width: 80%;
  margin: 3rem auto;
  section {
    text-align: center;
    width: 100%;
    a {
      display: block;
      img {
        width: 100%;
        height: 30rem;
      }
      p {
        margin: 1.5rem 0 3rem;
        font-size: 1.5rem;
        color: #999;
      }
    }
  }
  .douyin {
    position: relative;
    cursor: pointer;
    > img {
      width: 100%;
      height: 30rem;
    }
    .none {
      display: none;
    }
    > div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.5);
      img {
        height: 30rem;
      }
    }

    p {
      margin: 1.5rem 0 3rem;
      font-size: 1.5rem;
      color: #999;
    }
  }
  .douyin:hover > div {
    display: block;
  }
}
</style>
